// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio__radio___di0F1","outerCircle":"radio__outerCircle___2hqm6","innerCircle":"radio__innerCircle___2N_RV"};